import Collection from './sharing-collection';
import Model from './sharing-model';

export default {
  Collection,
  Model,
  namespace: 'sharing',
};
